import { useSyncExternalStore } from "react";

// Minimal hash router. Routes look like "#/projects/:id/board".
function subscribe(cb: () => void) {
  window.addEventListener("hashchange", cb);
  return () => window.removeEventListener("hashchange", cb);
}
function getSnapshot() {
  return window.location.hash || "#/";
}

export function useHash(): string {
  return useSyncExternalStore(subscribe, getSnapshot);
}

export function navigate(to: string) {
  if (!to.startsWith("#")) to = "#" + (to.startsWith("/") ? to : "/" + to);
  window.location.hash = to;
}

export interface Route {
  path: string; // e.g. "/projects" or "/projects/:id/board"
  parts: string[];
  params: Record<string, string>;
}

export function parseHash(hash: string): Route {
  const path = hash.replace(/^#/, "") || "/";
  const parts = path.split("/").filter(Boolean);
  return { path, parts, params: {} };
}

// Match a route pattern; returns params if it matches, else null.
export function match(pattern: string, route: Route): Record<string, string> | null {
  const pp = pattern.split("/").filter(Boolean);
  if (pp.length !== route.parts.length) return null;
  const params: Record<string, string> = {};
  for (let i = 0; i < pp.length; i++) {
    if (pp[i].startsWith(":")) params[pp[i].slice(1)] = decodeURIComponent(route.parts[i]);
    else if (pp[i] !== route.parts[i]) return null;
  }
  return params;
}
